import http from './http'

class Bank {
  fetch () {
    return http.get('/banks')
  }

  fetchByAssignor (id) {
    return http.get(`/banks/by_assignor/${id}/`)
  }
}

export default new Bank()



// WEBPACK FOOTER //
// ./src/services/bank.js